import type { ReportingVacancyFilters } from "./types";

export const REPORTING_VACANCY_PARAM_KEYS = [
  "department",
  "city",
  "vacancyId",
  "field",
  "company",
  "country",
] as const;

export function tenantClientParams(
  tenantId?: string,
  clientId?: string,
): { tenantId?: string; clientId?: string } {
  return {
    ...(tenantId?.trim() ? { tenantId: tenantId.trim() } : {}),
    ...(clientId?.trim() ? { clientId: clientId.trim() } : {}),
  };
}

export function buildReportingVacancyParams(
  vacancyFilters: ReportingVacancyFilters | undefined,
): Record<string, string[] | undefined> | undefined {
  if (
    !vacancyFilters ||
    !REPORTING_VACANCY_PARAM_KEYS.some((k) => (vacancyFilters[k]?.length ?? 0) > 0)
  ) {
    return undefined;
  }
  return Object.fromEntries(
    REPORTING_VACANCY_PARAM_KEYS.filter(
      (k) => (vacancyFilters[k]?.length ?? 0) > 0,
    ).map((k) => [k, vacancyFilters[k]]),
  );
}
